/**
 * v2 mock — shared slide-up slideshow.
 *
 * Markup contract:
 *   <div data-ww-slideshow data-ww-interval="5000">
 *     <div data-ww-slide> ... </div>   (2+ slides)
 *     ...
 *     <button data-ww-dot></button>    (optional, one per slide)
 *   </div>
 *
 * Fail-safe: base CSS shows only the FIRST slide. This module opts the container
 * into the animated stack by adding `.ww-js-slideshow`, so if the module never
 * runs (e.g. the Instagram in-app webview) slide 1 stays visible on its own.
 *
 * Reduced motion: honours prefers-reduced-motion by doing nothing — the base CSS
 * (slide 1 only, no auto-advance) is exactly the reduced-motion presentation.
 *
 * Motion: incoming slide rises from translateY(100%) to 0 while the outgoing one
 * moves to translateY(-100%); transform/opacity only, GPU-friendly. Auto-advance
 * pauses when the tab is hidden (visibilitychange).
 */
(function () {
  if (window.__wwSlideshowInit) return;
  window.__wwSlideshowInit = true;

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var TRANSITION_MS = 950;

  function initOne(root) {
    if (root.__wwSlideshow) return;
    root.__wwSlideshow = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ww-slide]'));
    if (slides.length < 2) return; // nothing to cycle
    if (reduce) return; // leave base CSS: slide 1 only, no motion

    var interval = parseInt(root.getAttribute('data-ww-interval'), 10) || 5000;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ww-dot]'));
    var current = 0;
    var timer = null;

    function setDot(i) {
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === i);
      });
    }

    // Opt into the animated stack, then immediately pin slide 0 active so there
    // is no flash between the fail-safe state and the JS state.
    root.classList.add('ww-js-slideshow');
    slides.forEach(function (s) {
      s.classList.remove('is-active', 'is-leaving', 'ww-slide--reset');
    });
    slides[0].classList.add('is-active');
    setDot(0);

    function advance() {
      var next = (current + 1) % slides.length;
      var leavingIndex = current;
      var leaving = slides[leavingIndex];
      var incoming = slides[next];

      incoming.classList.add('is-active'); // rises up from below
      leaving.classList.remove('is-active');
      leaving.classList.add('is-leaving'); // rises up and out

      current = next;
      setDot(current);

      // Once off-screen, snap the old slide back below without a visible move so
      // it is ready to re-enter on its next turn.
      window.setTimeout(function () {
        var l = slides[leavingIndex];
        l.classList.add('ww-slide--reset');
        l.classList.remove('is-leaving');
        void l.offsetHeight; // commit the instant reposition
        l.classList.remove('ww-slide--reset');
      }, TRANSITION_MS);
    }

    function start() {
      if (!timer) timer = window.setInterval(advance, interval);
    }
    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  function initAll() {
    document.querySelectorAll('[data-ww-slideshow]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
